import {
  IMG_ankhang,
  IMG_avacycle,
  IMG_avakids,
  IMG_bachhoaxanh,
  IMG_dienmaysupermini,
  IMG_dienmayxanh,
  IMG_thegioididong,
  IMG_topzone,
} from "../components/Img";

export interface ChainSheetLink {
  href: string;
  src: string;
  alt: string;
}

/** Public Google Sheet URLs for POSM distribution by chain. */
export const CHAIN_SHEET_ROWS: ChainSheetLink[][] = [
  [
    {
      href: "https://docs.google.com/spreadsheets/d/1Ygeyo3wVqJ4wcUJx-ypmzzayVIT-MGISH4gaDf3eJ8s/edit#gid=1284646124",
      src: IMG_thegioididong,
      alt: "Thế Giới Di Động",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/1OGhrbzNnBDdffbewlHDelITzkcBosP7Gp57uaD0BHyk/edit#gid=0",
      src: IMG_topzone,
      alt: "TopZone",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/11x0hFM04723SfiS3fMqI25Va2mke7bm7mPcfjL_XpYE/edit#gid=1284646124",
      src: IMG_dienmayxanh,
      alt: "Điện máy xanh",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/1kf1D0UMmO6AU5-NE14OL-Ab9B8OmVQWxKlwY1pyVPik/edit#gid=1284646124",
      src: IMG_dienmaysupermini,
      alt: "Điện máy Super Mini",
    },
  ],
  [
    {
      href: "https://docs.google.com/spreadsheets/d/1rHGYekU3dBAyQphoRzL57sf3HKNUzK2smop5AyYMiKU/edit#gid=1284646124",
      src: IMG_avacycle,
      alt: "AVA Cycle",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/1B73-nKS4oNg70MUaOM2cXSCP37YTD44iTs8XhEj6t_U/edit#gid=1284646124",
      src: IMG_avakids,
      alt: "AVA Kids",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/1-YTqI38kLrA4rNH6t_RY-26sOsR9WaKpCTX6BHt0odk/edit#gid=1109941482",
      src: IMG_bachhoaxanh,
      alt: "Bách Hóa Xanh",
    },
    {
      href: "https://docs.google.com/spreadsheets/d/18ndwc_bGQqu2wsDJ89leEZgg-HoMtoBQJO1QRSq12Bo/edit#gid=1284646124",
      src: IMG_ankhang,
      alt: "An Khang",
    },
  ],
];
